import type { DirectMessage } from '@/api/types'
import { cn } from '@/lib/cn'
import { useFormat } from '@/lib/format'

/** 一条私信。自己的靠右、亮绿；对方的靠左、浅底。时间悬停可见完整时刻。 */
export function MessageBubble({
  message,
  showTime,
}: {
  message: DirectMessage
  showTime: boolean
}) {
  const { relativeTime, absoluteTime } = useFormat()
  const mine = message.is_mine

  return (
    <div className={cn('flex flex-col px-4', mine ? 'items-end' : 'items-start')}>
      <p
        className={cn(
          'post-text max-w-[80%] px-3 py-2 text-[15px] leading-snug px-corners [--px-step:3px]',
          mine ? 'bg-brand text-on-brand' : 'bg-surface-subtle text-ink',
        )}
      >
        {message.content}
      </p>
      {showTime && (
        <time
          dateTime={message.created_at}
          title={absoluteTime(message.created_at)}
          className="mt-1 font-mono text-[12px] text-ink-muted"
        >
          {relativeTime(message.created_at)}
        </time>
      )}
    </div>
  )
}
